//#region redux
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { DialogEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import ImportCustomerDialogContent from "./importCustomerDialog";
import { RouteBreadCrumb } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useImportCustomerDialog() {
  const dispatch = useDispatch();

  const getImportCustomerDialog = (onFormSubmitSuccess?: () => void): DialogProps => {
    return {
      isOpen: false,
      title: (
        <RouteBreadCrumb
          current={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.ImportCustomerRegister)}
          showHome
        />
      ),
      dialogType: DialogEnums.DialogType.FullScreenNoSpeedDial,
      setDialogRef: true,
      children: <ImportCustomerDialogContent onFormSubmitSuccess={onFormSubmitSuccess} />,
    };
  };

  const showImportCustomerDialog = async (onFormSubmitSuccess?: () => void) => {
    dispatch(displayDialog(getImportCustomerDialog(onFormSubmitSuccess)));
  };

  return { showImportCustomerDialog };
}

export default useImportCustomerDialog;
